"use client";

import LegitScriptBadge from "~/componentsND/LegitScriptBadge";
import BaseFooter from "./BaseFooter";
import Heading from "~/componentsDS/Typography/Heading";

const Footer = () => {
    const topContent = (
        <div className="w-full lg:w-[310px] xl:w-[450px] 2xl:w-[550px]">
            <div className="flex flex-col gap-[12px]">
                <Heading as="h3" size="sm" sizes={{lg: "md"}} className="text-pureWhite leading-[1.1] tracking-[-1.2px]">
                    Sign up for the best <Heading as="i" weight="400" font="featureDisplay" className="text-[28px] lg:text-[36px] tracking-[-0.36px] leading-none">hormonal health</Heading> emails around, period.
                </Heading>
                <div className="klaviyo-form-SwbpCu" />
            </div>
        </div>
    );

    const sideContent = (
        <div className="max-md:w-[42%] max-md:grow">
            <LegitScriptBadge />
        </div>
    );

    return (
        <BaseFooter topContent={topContent} sideContent={sideContent} />
    );
};

export default Footer;
